/**
 * "Is the peer gone?" — the generalized freeze predicate (CD #15).
 *
 * A peer stops keeping your record in two ways, and both freeze your copy the
 * same way — live updates stop and the record becomes fully editable, like an
 * Anon contact you typed:
 *   - peerProfileDeleted — they deleted their whole account (their profiles row
 *     is gone). Set by reconcileDeletedMarks.
 *   - peerLeft — they deleted THIS connection (or their account's side of it);
 *     their side's *_left_at is set on connections, so the readers stopped
 *     delivering their live data to you. Latched by getLeftConnectionIds.
 *
 * Both are one-way latches stamped on anonData by the People / Chat enrichment.
 * This is the single predicate the name, contact-type, and inactive-status utils
 * read, so a left peer and a deleted-account peer behave identically.
 *
 * @param {Object|null} anonData - The connection's peer data (userData / anonData)
 * @returns {boolean}
 */
export const isPeerGone = (anonData) => !!(anonData?.peerProfileDeleted || anonData?.peerLeft);
